import { render, staticRenderFns } from "./ConfiguracionPacientes.vue?vue&type=template&id=67c35668&scoped=true"
import script from "./ConfiguracionPacientes.vue?vue&type=script&lang=js"
export * from "./ConfiguracionPacientes.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionPacientes.vue?vue&type=style&index=0&id=67c35668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c35668",
  null
  
)

export default component.exports